import {
	Directive,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnDestroy,
	OnInit,
	Output,
	Renderer2,
} from "@angular/core";

import { AccordionDirective } from "../accordion.directive";

@Directive({
	selector: "[obgAccordionHeader], obg-accordion-header",
})
export class AccordionHeaderDirective implements OnInit, OnDestroy {
	@Input() key: string | undefined;
	@Output() expandedChange = new EventEmitter<boolean>();

	constructor(
		private accordion: AccordionDirective,
		private renderer: Renderer2,
		private element: ElementRef
	) {}

	@HostListener("click")
	onClick() {
		if (this.key !== undefined) {
			this.accordion.toggle(this.key);
		}
	}

	ngOnInit() {
		if (this.key !== undefined) {
			this.accordion.register(this.key, { header: this });
		}
	}

	ngOnDestroy() {
		if (this.key !== undefined) {
			this.accordion.unregister(this.key);
		}
	}

	/**
	 * Used only internally within a sub-component.
	 */
	$$toggleHandler(expand: boolean, enableAnimation: boolean) {
		this.expandedChange.emit(expand);

		if (expand) {
			this.renderer.addClass(this.element.nativeElement, "expanded");
		} else {
			this.renderer.removeClass(this.element.nativeElement, "expanded");
		}

		if (enableAnimation) {
			this.renderer.removeClass(this.element.nativeElement, "no-animation");
		} else {
			this.renderer.addClass(this.element.nativeElement, "no-animation");
		}
	}
}
